import React, {useState, useContext} from "react"

// data & context
import data from "../../../data"
import {ShopContext} from "../../../context/ShopContext"

// controls
import {Button} from "./../../controls"

// styling
import "./CheckoutPromocode.scss"

// the component
function CheckoutPromocode() {
  // state management
  const [code, setCode] = useState("")
  const [validation, setValidation] = useState(null)
  
  // get the shop context
  let shop = useContext(ShopContext)

  // if we already have a promo code we do not display this
  if(data.Cart.getVoucher()) {
    return null
  }
  
  // if there are no items in the cart, we don't display this
  if(shop.cartActivities.length === 0) {
    return null
  }

  // funcs
  const serverValidate = async() => {
    let result = await data.Promocode.validate(code)
    shop.cart.setVoucher(result.voucher || null)
    let validation = data.Cart.getVoucherValidation()
    setValidation(validation)
  }

  // render
  let validationError = null
  //let voucherValidation = data.Cart.getVoucherValidation()
  if(validation && validation.valid === false) {
    validationError = (
      <div className="validation-error">{validation.message}</div>
    )
  }
  return (
    <div id="v-promocode">
      <h3>Du hast einen Promocode?</h3>
      <div className="input-and-button">
        <input 
          type="text" 
          placeholder="Promocode eingeben"
          value={code}
          onChange={e => {
            setCode(e.target.value.toUpperCase())
          }}
        />
        <Button
          onClick={serverValidate}
          disabled={code.trim().length === 0}
        >
          einlösen
        </Button>
      </div>
      
      {validationError}
      
    </div>
  )
}

export default CheckoutPromocode